import styled from 'styled-components';

import { fonts } from '@dreryk/react-components';

const StyledMedicineDetailsAdditionalInformationContent = styled.div`
   display: grid;
   grid-template-columns: auto 1fr;
   grid-column-gap: 20px;
   grid-row-gap: 10px;
   > div:first-child {
      grid-column: 1 / 3;
   }
`;

StyledMedicineDetailsAdditionalInformationContent.displayName = 'StyledMedicineDetailsAdditionalInformationContent';

export { StyledMedicineDetailsAdditionalInformationContent };

export const StyledMedicineDetailsAdditionalInformationItem = styled.div`
   display: flex;
   flex-direction: row;
   grid-gap: 6px;

   > div:first-child {
      font-weight: ${fonts.fontWeightBold};
      white-space: nowrap;
   }
`;
StyledMedicineDetailsAdditionalInformationItem.displayName = 'StyledMedicineDetailsAdditionalInformationItem';
